import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import ButtonBase from "@material-ui/core/ButtonBase"

// import Button from "../LandingComponents/Button"
import Link from "../Link"
import Img from "gatsby-image"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    height: "100%",
    //maxWidth: 500,
  },
  image: {
    width: 128,
    height: 128,
  },
  // img: {
  //   margin: "auto",
  //   display: "block",
  //   maxWidth: "100%",
  //   maxHeight: "100%",
  // },
}))

export default function NewsCard({ node }) {
  const classes = useStyles()

  return (
    <Link className={classes.root} underline="none" to={node.fields.slug}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item>
            <ButtonBase className={classes.image}>
              <Img
                style={{
                  maxHeight: 128,
                }}
                fixed={node.frontmatter.featuredImage.childImageSharp.fixed}
                title={node.frontmatter.title}
                alt={node.frontmatter.title}
              />
            </ButtonBase>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {node.frontmatter.title}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {node.frontmatter.date}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {node.excerpt}
                </Typography>
              </Grid>
              {/* <Grid item>
                <Button
                  size="small"
                  color="primary"
                  component={Link}
                  to={node.fields.slug}
                >
                  View
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Link>
  )
}

NewsCard.propTypes = {
  node: PropTypes.object.isRequired,
}
